import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Headline1 = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M25.212 5c0.42 0 0.76 0.374 0.76 0.837v8.163c0 0.67-0.43 1-0.986 1-0.42 0-0.986-0.436-0.986-1v-6l-0.752 0.61c-0.43 0.32-1.093-0.14-1.22-0.507-0.127-0.37-0.050-0.885 0.336-1.24l1.934-1.595c0.132-0.108 0.358-0.268 0.914-0.268zM18 9c0.553 0 1 0.447 1 1v16c0 0.553-0.447 1-1 1-0.552 0-1-0.447-1-1v-7h-9v7c0 0.553-0.447 1-1 1-0.552 0-1-0.447-1-1v-16c0-0.553 0.448-1 1-1 0.553 0 1 0.447 1 1v7h9v-7c0-0.553 0.448-1 1-1z" />
  </SvgIcon>
);

export default Headline1;
